class playAudio {
	constructor()
	  {
			console.log('audioPlay---1');
			// If new file is added or changed from this list code has to be changed too
			this.audio = {
				'ding' : {'link': './audio/conetouch.mp3', 'audio': false},
				'pauseDing' : {'link': './audio/pauseDing.mp3', 'audio': false},
				'notify' : {'link': './audio/notify.mp3', 'audio': false},
				'squat' : {'link': './audio/squatTouch.mp3', 'audio': false},
				'over' : { 'link': './audio/over_sound.mp3', 'audio': false },
				'allDone' : { 'link': './audio/all_done.mp3', 'audio': false, 'priority': 'high' },
				'height' : { 'link': './audio/height_photo.mp3', 'audio': false },
				'countdown' : { 'link': './audio/countdown15.mp3', 'audio': false },
				'unabletofind' : { 'link': './audio/unabletofind.mp3', 'audio': false },
				'outside' : { 'link': './audio/outside.mp3', 'audio': false },
				'buzz' : { 'link': './audio/buzz.mp3', 'audio': false },
				'moveback' : { 'link': './audio/moveout.mp3', 'audio': false },
				'hit' : { 'link': './audio/baghit.mp3', 'audio': false },
				'emptyroom' : { 'link': './audio/empty_room.mp3', 'audio': false },
				'viewcaptured' : { 'link': './audio/viewcaptured.mp3', 'audio': false },
				'roomSetup' : { 'link': './audio/RoomSetup.mp3', 'audio': false },
				'emptyRoomIssue' : { 'link': './audio/empty_room_issue.mp3', 'audio': false },
				'imageTaken' : { 'link': './audio/image_taken.mp3', 'audio': false },
				'heightError' : { 'link': './audio/height_error.mp3', 'audio': false },
				'heightSuccess' : { 'link': './audio/height_success.mp3', 'audio': false },
				'count321' : { 'link': './audio/count_3_2_1.mp3', 'audio': false },
				'countreadyset' : { 'link': './audio/countreadyset.mp3', 'audio': false },
				'donesound' : { 'link': './audio/donesound.mp3', 'audio': false, 'priority': 'high' },
				'bell' : { 'link': './audio/bell_sound.mp3', 'audio': false, 'priority': 'high' },
				'go' : { 'link': './audio/go_sound.mp3', 'audio': false, 'priority': 'high' },
				'ready' : { 'link': './audio/ready.mp3', 'audio': false, 'priority': 'high' },
				'inRoomPicture' : { 'link': './audio/Voice-Participant-SillInCameraView.mp3', 'audio': false },
				'heightNotInZone' : { 'link': './audio/Voice-Participant-HeightNotInActiveZoneYet.mp3', 'audio': false },
				'roomFailedSuccess' : { 'link': './audio/Voice-Participant-IssueButImageSuccess.mp3', 'audio': false },
				'bagDirections' : { 'link': './audio/Voice-Host-MovePunchingBag-Short.mp3', 'audio': false },
				'coneDirections' : { 'link': './audio/Voice-Host-MoveCones-Shortt.mp3', 'audio': false },
				'squatDirections' : { 'link': './audio/Voice-Host-SquatSetup-Short.mp3', 'audio': false },
				'boxingBothSetup' : { 'link': './audio/Voice-Participant-SetupBoxing-Short.mp3', 'audio': false },
				'boxingHostSetup' : { 'link': './audio/Voice-Host-BoxingPressSetupEquipment.mp3', 'audio': false },
				'coneBothSetup' : { 'link': './audio/Voice-Participant-SetupCones-Short.mp3', 'audio': false },
				'coneHostSetup' : { 'link': './audio/Voice-Host-ConesPressSetupEquipment.mp3', 'audio': false },
				'boxingSetupPar' : { 'link': './audio/Voice-Participant-HostSetupBoxing.mp3', 'audio': false },
				'coneSetupPar' : { 'link': './audio/Voice-Participant-HostSetupCones.mp3', 'audio': false },
				'squatSetupPar' : { 'link': './audio/Voice-Participant-HostSquatsSetup.mp3', 'audio': false },
				'readyGo' : { 'link': './audio/ready_go.mp3', 'audio': false },
				'squatHostSetup' : { 'link': './audio/Voice-Host-SquatSetup.mp3', 'audio': false },
				'squatBothSetup' : { 'link': './audio/Voice-Host-SquatSetup-Short2.mp3', 'audio': false },
				'boxingParInstructions' : { 'link': './audio/Voice-Participant-BoxingInstructions-Short.mp3', 'audio': false },
				'boxingParInstructionsLong' : { 'link': './audio/Voice-Participant-BoxingInstructions.mp3', 'audio': false },
				'coneParInstructions' : { 'link': './audio/Voice-Participant-ConesInstructions-Short.mp3', 'audio': false },
				'coneParInstructionsLong' : { 'link': './audio/Voice-Participant-ConesInstructions.mp3', 'audio': false },
				'boxingWalkToZone' : { 'link': './audio/Voice-Participant-WalkToBoxingActiveZone.mp3', 'audio': false },
				'squatWalkToZone' : { 'link': './audio/Voice-Participant-WalkToConesActiveZone.mp3', 'audio': false },
				'coneWalkToZone' : { 'link': './audio/Voice-Participant-WalkToSquatActiveZone.mp3', 'audio': false },
				'startRoomSetup' : { 'link': './audio/Voice-Host-RoomSetup-Revised-Short.mp3', 'audio': false },
				'allInPosition' : { 'link': './audio/Voice-Host-EquipmentSetupForAllStartActivity.mp3', 'audio': false },
				'someInPosition' : { 'link': './audio/Voice-Host-EquipmentSetupForSomeStartActivity.mp3', 'audio': false },
				'emptyRoomNew' : { 'link': './audio/Voice-Participant-EmptyRoomImageClearView.mp3', 'audio': false },
				'stayOut' : { 'link': './audio/Voice-Participant-OutOfCameraView.mp3', 'audio': false },
				'startRoomSetupPart' : { 'link': './audio/Voice-Participant-StartRoomSetup-Revised-Short.mp3', 'audio': false },
				'startRoomSetupPartLong' : { 'link': './audio/Voice-Participant-StartRoomSetup-Revised2.mp3', 'audio': false },
				'startRoomSetupPartHost' : { 'link': './audio/Voice-Participant-RoomSetup-Short.mp3', 'audio': false },
				'startRoomSetupPartLongHost' : { 'link': './audio/Voice-Participant-StartRoomSetup.mp3', 'audio': false },
				'allowConeSetup' : { 'link': './audio/Voice-Participant-AllowSetupCones-Short.mp3', 'audio': false },
				'allowConeSetupLong' : { 'link': './audio/Voice-Participant-AllowedSetupCones.mp3', 'audio': false },
				'allowConeBoxing' : { 'link': './audio/Voice-Participant-AllowSetupBoxing-Short.mp3', 'audio': false },
				'allowBoxingSetupLong' : { 'link': './audio/Voice-Participant-AllowSetupBoxing.mp3', 'audio': false },
				'partHeightSuccess' : { 'link': './audio/Voice-Participant-HeightSuccessful.mp3', 'audio': false },
				'moveToCenterCone' : { 'link': './audio/Voice-Participant-ConesMoveToCenterOfCircle.mp3', 'audio': false },
				'moveToCenterBoxing' : { 'link': './audio/Voice-Participant-BoxingMoveToCenterOfCircle.mp3', 'audio': false },
				'workoutAreaSetup' : { 'link': './audio/Voice-Participant-ActiveWorkoutArea-WBR.mp3', 'audio': false },
				'workoutAreaSetupDone' : { 'link': './audio/Voice-Participant-ActiveWorkoutArea-Done.mp3', 'audio': false },
				'workoutAreaSetupDone2' : { 'link': './audio/Voice-Participant-ActiveWorkoutArea-Done2.mp3', 'audio': false },
				'workoutAreaSetupMFL' : { 'link': './audio/Voice-Participant-ActiveWorkoutArea-MFL.mp3', 'audio': false },
				'workoutAreaSetupWFL' : { 'link': './audio/Voice-Participant-ActiveWorkoutArea-WFL.mp3', 'audio': false },
				'workoutAreaSetupMBL' : { 'link': './audio/Voice-Participant-ActiveWorkoutArea-MBL.mp3', 'audio': false },
				'workoutAreaSetupWBL' : { 'link': './audio/Voice-Participant-ActiveWorkoutArea-WBL.mp3', 'audio': false },
				'workoutAreaSetupMBR' : { 'link': './audio/Voice-Participant-ActiveWorkoutArea-MBR.mp3', 'audio': false },
				'roomSetupRight' : { 'link': './audio/Virdio-Audio-RS-RightSide.mp3', 'audio': false },
				'roomSetupLeft' : { 'link': './audio/Virdio-Audio-RS-LeftSide.mp3', 'audio': false },
				'roomSetupPerfect' : { 'link': './audio/Virdio-Audio-RS-Perfect.mp3', 'audio': false },
				'stepInZone' : { 'link': './audio/Ding_Sound_Effect.mp3', 'audio': false },
				'reactionBackCenter' : { 'link': './audio/R_center.mp3', 'audio': false },
				'reactionBackLeft' : { 'link': './audio/R_backleft.mp3', 'audio': false },
				'reactionBackRight' : { 'link': './audio/Reaction_Backright.mp3', 'audio': false },
				'reactionForwardCenter' : { 'link': './audio/Reaction-Drill-Forward-Center.mp3', 'audio': false },
				'reactionFrontLeft' : { 'link': './audio/R_frontleft.mp3', 'audio': false },
				'reactionFrontRight' : { 'link': './audio/R_frontright.mp3', 'audio': false },
				'roomSetupCircle' : { 'link': './audio/Media-InitialMsg.mp3', 'audio': false },
				'startRoomSetupButton' : { 'link': './audio/RoomSetup_audionew.mp3', 'audio': false },
				'wasFirstCone' : { 'link': './audio/BackRightCone.mp3', 'audio': false },
				'wasSecondCone' : { 'link': './audio/FrontLeftCone.mp3', 'audio': false },
				'wasThirdCone' : { 'link': './audio/FrontLeftCone.mp3', 'audio': false },
				'wasFourthCone' : { 'link': './audio/WASDone.mp3', 'audio': false },
				'topAndBottomBarAudio' : { 'link': './audio/RoomSetupAudio.mp3', 'audio': false },
				'mediaRedo' : { 'link': './audio/Media-Redo.mp3', 'audio': false },
				'mediaFail' : { 'link': './audio/Media-Fail.mp3', 'audio': false },
				'mediaFinal' : { 'link': './audio/Media-Final.mp3', 'audio': false },
				'mediaFreeze' : { 'link': './audio/Media-Freeze.mp3', 'audio': false },
				'BeforeRoomSetup' : { 'link': './audio/BeforeRoomSetup.mp3', 'audio': false },
				'ContinuePlayRoomSetup' : { 'link': './audio/ContinuePlayRoomSetup.mp3', 'audio': false }
			};
			console.log('audioPlay---2', this.audio);
			
			this.excludeAudioStop = ['ding', 'squat', 'over', 'allDone', 'outside', 'buzz', 'moveback', 'hit'];
			console.log('audioPlay---3');
			
			this.sep = '~@$';
			this.bellPlayedTime = 0;
			this.hitPlayedTime = 0;
			
			this.oldAudio = {};
			this.isCompleted = true;
			this.isStarted = false;
			this.setupListenerAudioMixing = false;
			this.dontStopNext = false;
			
			this.playingTotalSounds = 0;
			console.log('audioPlay---4');
			
			if ( window['electron'] && window['fsFile'] && window['recordingPath'] )
				{
					console.log('audioPlay---5');
					if ( window['fsFile'].existsSync(window['recordingPath'].replace(/\\/g, '/')+'/audio') )
						{
							console.log('audioPlay---6');
							var found_files = window['fsFile'].readdirSync(window['recordingPath'].replace(/\\/g, '/')+'/audio');
							console.log('audioPlay---7');
							
							// Count of audio files above, one file is duplicated
							if ( found_files.length !== this.audio.length )
								{
									console.log('audioPlay---8');
									window['fsFile'].rmdirSync(window['recordingPath'].replace(/\\/g, '/')+'/audio', { recursive: true });
									console.log('audioPlay---9');
								}
							console.log('audioPlay---10');
						}
					console.log('audioPlay---11');
					
					if ( !window['fsFile'].existsSync(window['recordingPath'].replace(/\\/g, '/')+'/audio') )
						{
							console.log('audioPlay---12');
							window['fsFile'].mkdirSync(window['recordingPath'].replace(/\\/g, '/')+'/audio');
							console.log('audioPlay---13');
							for ( var af in this.audio )
								{
									//console.log('audioPlay---14');
									var currentURL = window['applicationPath']+'/build/'+this.audio[af]['link'].replace('./', '');
									//console.log('audioPlay---15');
									window['fsFile'].copyFileSync(currentURL, window['recordingPath'].replace(/\\/g, '/')+'/'+this.audio[af]['link'].replace('./', ''));
									//console.log('audioPlay---16');
								}
							console.log('audioPlay---17');
						}
					console.log('audioPlay---18');
				}
		console.log('audioPlay---19');
		
		window['playDefaultSpeaker'] = true;
		console.log('audioPlay---20');
		window['playAudio'] = this.playAudio;
		console.log('audioPlay---21');
		window['stopAudio'] = this.stopAudio;
		console.log('audioPlay---22');
	  }
	
	playAudio = (audio, stopAllSame) =>
		{
			console.log('PLAY AUDIO', audio);
			if ( !audio || !this.audio[audio] ) { return false; }
			
			if ( window['guestUser'] )
				{
					window['globalRTM'](window['currentUserData']['sessionData']['hostEmail'], 'audioPlaying'+this.sep);
				}
			
			if ( !this.audio[audio]['audioList'] ) { this.audio[audio]['audioList'] = []; }
			
			if ( stopAllSame )
				{
					for ( var oneS of this.audio[audio]['audioList'] )
						{
							if ( oneS && oneS.hasAttribute('data-myId') && this.audio[audio]['audioList'][parseInt(oneS.getAttribute('data-myId'))] )
								{
									this.audio[audio]['audioList'][parseInt(oneS.getAttribute('data-myId'))] = false;
									this.playingTotalSounds--;
								}
						}
				}
			
			var newAudioEl = new Audio(this.audio[audio]['link']);
			//newAudioEl.['myId'] = this.audio[audio]['audioList'].length;
			newAudioEl.setAttribute('data-myId',  this.audio[audio]['audioList'].length);
			this.matchSpeakerDevice(newAudioEl);
			
			this.audio[audio]['audioList'].push(newAudioEl);
			
			let mainthis = this;
			window.$(newAudioEl).on('ended', function (e) {
				console.log(this.getAttribute('data-myId'), 'dataMyid2');
				if ( this.hasAttribute('data-myId') && mainthis.audio[audio]['audioList'][parseInt(this.getAttribute('data-myId'))] )
					{
						mainthis.audio[audio]['audioList'][parseInt(this.getAttribute('data-myId'))] = false;
					}
				
				mainthis.playingTotalSounds--;
				
				if ( mainthis.playingTotalSounds == 0 )
					{
						if ( window['guestUser'] )
							{
								window['globalRTM'](window['currentUserData']['sessionData']['hostEmail'], 'audioStopped'+mainthis.sep);
							}
					}
			});
			
			this.playingTotalSounds++;
			newAudioEl.play();
		}
	
	stopAudio = (audio) => {
		if ( window['guestUser'] )
			{
				window['globalRTM'](window['currentUserData']['sessionData']['hostEmail'], 'audioStopped'+this.sep);
			}
			
		if ( audio && this.audio[audio] && this.audio[audio]['audioList'] )
			{
				for ( var oneS of this.audio[audio]['audioList'] )
					{
						if ( oneS && oneS.hasAttribute('data-myId') && this.audio[audio]['audioList'][parseInt(oneS.getAttribute('data-myId'))] )
							{
								this.audio[audio]['audioList'][parseInt(oneS.getAttribute('data-myId'))] = false;
								this.playingTotalSounds--;
							}
					}
			}
		else if ( !audio && this.audio )
			{
				for (var key of Object.keys(this.audio)) {
					if ( this.audio[key]['audioList'] )
						{
							for ( var oneS of this.audio[key]['audioList'] )
								{
									if ( oneS && oneS.hasAttribute('data-myId') && this.audio[key]['audioList'][parseInt(oneS.getAttribute('data-myId'))] )
										{
											this.audio[key]['audioList'][parseInt(oneS.getAttribute('data-myId'))].pause();
											this.audio[key]['audioList'][parseInt(oneS.getAttribute('data-myId'))] = false;
											this.playingTotalSounds = 0;
										}
								}
						}
				}
			}
	}
	
	matchSpeakerDevice(audioElement)
		{
			if ( window['globalAgora'] && window['globalAgora']['agora'] )
				{
					var maxDevice = [0, ''];
					
					var agoraDevices = window['globalAgora']['agora'].getAudioPlaybackDevices();
					var agoraCurrentDevice = window['globalAgora']['agora'].getCurrentAudioPlaybackDevice();
					
					if ( agoraDevices && agoraCurrentDevice )
						{
							for ( var sdevice of agoraDevices )
								{
									if ( sdevice['deviceid'] == agoraCurrentDevice )
										{
											var matchingDevice = sdevice;
											var mainthis = this;
											navigator.mediaDevices.enumerateDevices().then(function(JSdevices)
												{
													var audioDevices = JSdevices.filter(device => device.kind === 'audiooutput');
													
													for ( var adevice of audioDevices )
														{
															var nowDevice = mainthis.matchDevicesByName(adevice['label'], matchingDevice['devicename']);
															if ( nowDevice > maxDevice[0] ) { maxDevice[0] = nowDevice; maxDevice[1] = adevice['deviceId']; }
														}
													
													if ( maxDevice[0] && maxDevice[1] )
														{
															audioElement.setSinkId(maxDevice[1]);
														}
												});
										}
								}
						}
				}
		}
	
	matchDevicesByName(name1, name2)
		{
			var name1Array  = name1.split(/\W+/);
			var name2Array  = name2.split(/\W+/);
			var resultArray = name2Array.filter(function(obj) { return name1Array.indexOf(obj) != -1; });

			return resultArray.length;
		}
}

export default playAudio;